export const validateTestCardFlag = (cardNumber: string): boolean => {
  return cardNumber === '5031433215406351';
};
